import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import 'react-table/react-table.css';
import UploadFile from './UploadRxComponents/UploadFile.js';

function UploadRxModal({ onClose }) {
  return (
    <Modal
      isOpen={true}
      style={{ maxWidth: '760px', width: '100%' }}
    >
      <ModalHeader
        toggle={onClose}
        style={{
          background: 'linear-gradient(135deg, #6C5DD3 0%, #8b7cf6 100%)',
          border: 'none',
          padding: '18px 24px',
        }}
        cssModule={{ 'modal-title': 'w-100' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '32px', height: '32px', borderRadius: '8px',
            background: 'rgba(255,255,255,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '16px', flexShrink: 0,
          }}>
            📋
          </div>
          <div>
            <div style={{ color: '#fff', fontWeight: '700', fontSize: '15px', lineHeight: 1.2 }}>
              Upload Prescriptions
            </div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px', fontWeight: '400', marginTop: '2px' }}>
              Search patient → select details → upload files
            </div>
          </div>
        </div>
      </ModalHeader>
      <ModalBody style={{ padding: '20px', background: '#f8fafc' }}>
        <UploadFile onClose={onClose} />
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  user: state.user,
});

export default connect(mapStateToProps)(UploadRxModal);
